import { SOURCES } from 'features/new-candidate/constants';

export const getInitialFetcherParams = queryParams => {
  if (!queryParams) return null;
  if (!queryParams?.draftId) return queryParams;

  return {
    ...queryParams,
    id: queryParams.draftId,
    isFromDraft: true
  };
};

export const getInitialSource = queryParams =>
  queryParams?.draftId ? SOURCES.FROM_DRAFT : queryParams?.source || null;
